import axiosInstance from "~/shared/api/axios-instance";

const API_URL = "account/logout/";

export const logout = async () => {
  const { data } = await axiosInstance.post(API_URL);
  return data;
};
